import React from "react";
import LogRow from "./LogRow";

// Timestamp | Level | Action | Host | User
const COLS = "170px 86px 200px 140px 1fr";

export default function LogsTable({ styles, rows, logsLoading, selected, setSelected }) {
  const headerStyle = {
    display: "grid",
    gridTemplateColumns: COLS,
    gap: 12,
    alignItems: "center",
    padding: "10px 12px",
    fontSize: 12,
    letterSpacing: 0.2,
    opacity: 0.8,
    borderBottom: "1px solid rgba(15,23,42,0.088)",
    position: "sticky",
    top: 0,
    background: "rgba(248,249,251,0.96)",
    backdropFilter: "blur(8px)",
    zIndex: 2,
  };

  return (
    <div style={styles.tableCard}>
      <div style={headerStyle}>
        <div>Zeit</div>
        <div>Level</div>
        <div>Aktion</div>
        <div>Host-Code</div>
        <div>Nutzer</div>
      </div>

      <div className="scrollbar-dark" style={{ ...styles.list, padding: 0 }}>
        {rows.length === 0 ? (
          <div style={{ ...styles.empty, padding: 16 }}>
            {logsLoading ? "Logs werden geladen …" : "Keine Logs für diese Auswahl."}
          </div>
        ) : (
          rows.map((r, i) => (
            <LogRow
              key={`${r.timestamp}-${i}`}
              styles={styles}
              r={r}
              i={i}
              selected={selected}
              setSelected={setSelected}
              cols={COLS}
            />
          ))
        )}
      </div>

      <div style={styles.footerRow}>
        <div style={{ fontSize: 12, opacity: 0.75 }}>
          <b>{rows.length}</b> Einträge
        </div>

        <button
          style={styles.button(false)}
          onClick={() => setSelected(null)}
          disabled={!selected}
          title="Detailansicht schließen"
        >
          Details schließen
        </button>
      </div>
    </div>
  );
}
